export const STRIPE_KEY = 'pk_live_eCffHUo8C98ex1XAZKUIG5sk';// 'pk_test_LsZ8a24e5UDFhG9CXud6hz9y' pk_live_eCffHUo8C98ex1XAZKUIG5sk;
export const COST = 349 * 100;
export const CURRENCY = 'EUR';



// WEBPACK FOOTER //
// ./src/constants/stripe.js